module.exports = __webpack_public_path__ + "static/media/sub-weapon.4bb5a75b.png";